<template lang="pug">
div
  | Preset:
  select(v-model="preset")
    option(:value="null") Select
    option(:disabled="true") -
    option(v-for="o in presetOptions", :value="o.value") {{ o.name }}
  table.filters
    tr
      th(v-for="f in filters") {{ f.short }}
    tr
      td(v-for="(f, i) in filters")
        input(type="checkbox", v-model="params.colors[i].enabled")
    tr
      td(v-for="(f, i) in filters")
        color-picker(v-model="params.colors[i].value", :alpha="false")
    tr(v-for="j in [0, 1, 2]")
      td(v-for="(f, i) in filters")
        input(
          type="text",
          v-model="params.colors[i].value[j]",
          size="4",
          :disabled="!params.colors[i].enabled"
        )
  table
    tr
      th &beta;
      td
        log-scale-range(v-model="params.beta", :min="0", :max="2e8")
    tr
      th b<sub>0</sub>
      td
        range-slider(
          v-model.number="params.b0",
          min="0",
          max="5.e-5",
          step="1.e-8",
          style="width: 100%"
        )
    tr
      th A
      td
        log-scale-range(v-model.number="params.a", :min="0", :max="1e4")
    tr
      th bias
      td
        log-scale-range(
          v-model.number="params.bias",
          :min="-0.5",
          :max="0.5",
          :a="1e-8"
        )
  //- pre {{ JSON.stringify(params, null, 2) }}
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from "vue-property-decorator"
import { Params } from "@/modules/SspDataModule"
import { env, envName } from "@/env"
import { store } from "@/store"
import { generateCombinations } from './generateCombinations'

@Component
export default class extends Vue {
  @Prop({ required: true })
  params!: Params["simpleColorMatrix"]

  get logBeta() {
    return Math.log(this.params.beta)
  }
  set logBeta(beta: number) {
    this.params.beta = Math.exp(beta)
  }

  get filters() {
    if (envName === 'public-release-2-chorus' && store.currentFrame.modules.sspData.activeReruns.indexOf('chorus-s18a-da908ee467204a79') < 0) {
      const chorus_filters = ['NB0527', 'NB0718', 'IB0945', 'NB0973']
      return this.Env.filters.filter(f => chorus_filters.indexOf(f.value) < 0)
    }
    return this.Env.filters
  }

  preset: null | { filterName: string, value: [number, number, number] }[] = null
  get presetOptions(): { name: string, value: { filterName: string, value: [number, number, number] }[] }[] {
    const filters = env.filters.filter(f => !f.type)
    const options: { name: string, value: { filterName: string, value: [number, number, number] }[] }[] = []
    for (const n of [1, 2, 3]) {
      generateCombinations(filters.length, n, filterIndices => {
        options.push({
          name: filterIndices.map(i => filters[i].short).join('-'),
          value: filterIndices.map((i, j) => ({
            filterName: filters[i].value,
            value: ([
              [],
              [[1, 1, 1]],
              [[0, 0.5, 1], [1, 0.5, 0]],
              [[0, 0, 1], [0, 1, 0], [1, 0, 0]],
            ] as [number, number, number][][])[n][j],
          }))
        })
      })
    }
    return options
  }

  @Watch('preset')
  onPresetChange() {
    if (this.preset !== null) {
      for (const c of this.params.colors) {
        const newColor = this.preset.find(c1 => c.filterName === c1.filterName)
        if (newColor) {
          c.enabled = true
          c.value = newColor.value
        }
        else {
          c.enabled = false
          c.value = [0, 0, 0]
        }
      }
    }
    this.preset = null
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
}

.filters {
  td {
    text-align: center;
  }
}

th {
  width: 20%;
}
</style>